import { render, staticRenderFns } from "./FileSizeCheck.vue?vue&type=template&id=623f16a0&scoped=true&"
import script from "./FileSizeCheck.vue?vue&type=script&lang=js&"
export * from "./FileSizeCheck.vue?vue&type=script&lang=js&"
import style0 from "./FileSizeCheck.vue?vue&type=style&index=0&id=623f16a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../workspace/yajatravel/mp/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623f16a0",
  null
  
)

export default component.exports